import { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./CategoryHeaderDescription.css";

const CategoryHeaderDescription = ({ viewport, description }) => {
  if (!description) {
    return null;
  }

  const [expanded, setExpanded] = useState(false);
  const shortenedDescription = description.slice(0, 45);

  useEffect(() => {
    setExpanded(false);
  }, [viewport]);

  const onClick = useCallback(() => {
    setExpanded(!expanded);
  });

  return (
    <>
      <button
        className={styles.button}
        aria-controls="descriptionContainer"
        aria-expanded={expanded}
        onClick={onClick}
      >
        <div className={styles.container} id="descriptionContainer">
          <p
            className={classNames(styles.shortenedDescription, {
              [styles.hide]: expanded
            })}
          >
            {shortenedDescription}
          </p>
          {!expanded && description && <span aria-hidden="true">...</span>}
          <noscript className={styles.hiddenDescription}>
            {description}
          </noscript>
          <p
            aria-hidden={!expanded}
            className={classNames(styles.hide, {
              [styles.expanded]: expanded
            })}
          >
            {description}
          </p>
          <div
            className={classNames(styles.icon, {
              [styles.iconUp]: expanded
            })}
          />
        </div>
      </button>
    </>
  );
};

CategoryHeaderDescription.propTypes = {
  description: PropTypes.string,
  viewport: PropTypes.string.isRequired
};

export default CategoryHeaderDescription;
